__turbopack_context__.v({
  "appIcon": "app-module__FbCvrW__appIcon",
  "appWithUrl": "app-module__FbCvrW__appWithUrl",
});
